import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			redirect: '/top'
		},
		...['top', 'new', 'show', 'ask', 'job'].map(type => ({
			name: type,
			path: '/' + type,
			component: () => import('./views/ListView.vue'),
			props: {type}
		})),
		{
			path: '/item/:id',
			name: 'item',
			component: () => import('./components/Item.vue')
		},
		{
			path: '/about',
			name: 'about',
			component: () => import('./views/About.vue')
		},
		{
			path: "*",
			redirect: "/top"
		}
	]
})
